export default "__VITE_ASSET__536d02c6__"